/**
 * Resolve a translated field value from an entity's translations dict.
 *
 * @param translations - The entity's translations dict, e.g. { "title": { "fr": "Titre" } }
 * @param field - The model field name (translation key), e.g. "title", "name", "display_name"
 * @param lang - Current language code, e.g. "fr"
 * @param fallback - The base English value to use when no translation exists
 */
export function tr(
  translations: Record<string, Record<string, string>> | undefined,
  field: string,
  lang: string,
  fallback: string
): string {
  if (!translations || lang === 'en') return fallback
  return translations[field]?.[lang] || fallback
}
